module.exports = __webpack_public_path__ + "static/media/close-x.b8802c13.svg";